import { handleActions } from 'redux-actions';
import * as types from './types';
import * as userSettingsTypes from '../UserSettings/types';

import { excludeIntacctId, includeIntacctId, sortObjectsByNameAsc } from '../../helpers/utils';
import { cloneDeep } from 'lodash';

const initialState = {
  data: [],
  error: null,
  initialLoad: false,
  loading: false,
  saving: false,
};

const getItemsRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getItemsRequestFailure = (state, action) => {
  return {
    ...state,
    data: [],
    error: action.error,
    loading: false,
  };
};
const getItemsRequestSuccess = (state, payload) => {
  let data = payload.data.res;
  if (payload.data.showIntacctId) {
    data.map((d) => includeIntacctId(d));
  }
  data.sort(sortObjectsByNameAsc);
  return {
    ...state,
    data,
    initialLoad: true,
    error: null,
    loading: false,
  };
};

const showIntacctId = (state) => {
  const data = cloneDeep(state.data);
  data.map((d) => includeIntacctId(d));
  data.sort(sortObjectsByNameAsc);
  return {
    ...state,
    data,
  };
};
const hideIntacctId = (state) => {
  const data = cloneDeep(state.data);
  data.map((d) => excludeIntacctId(d));
  data.sort(sortObjectsByNameAsc);
  return {
    ...state,
    data,
  };
};

export default handleActions(
  {
    [types.GET_ITEMS_REQUEST]: getItemsRequest,
    [types.GET_ITEMS_REQUEST_FAILURE]: getItemsRequestFailure,
    [types.GET_ITEMS_REQUEST_SUCCESS]: getItemsRequestSuccess,
    [userSettingsTypes.SHOW_INTACCT_ID]: showIntacctId,
    [userSettingsTypes.HIDE_INTACCT_ID]: hideIntacctId,
  },
  initialState
);
